import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { DrawFunds } from 'merchant-components'

export const Route = createFileRoute('/_merchant/_portal/drawfunds')({
  component: DrawFunds,
})
